import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const NorthernMarianaIslands: Country = {
    identifier: "NorthernMarianaIslands",
    name: "Northern Mariana Islands",
    countryCode: "MP",
    group: CountryGroup.OCEANIA,
    isUNMember: false,
    flag: "🇲🇵",
    svgPath: "m 883.82475,409.6444 -0.086,0.11 -0.071,-0.081 -0.02,-0.16 0.125,0.015 0.046,0.033 0.006,0.083 z m 0.193,2.01 -0.136,0.064 0.169,-0.289 0.051,-0.05 0.079,0.105 -0.163,0.17 z m -0.183,5.08 -0.062,0.02 -0.089,-0.01 -0.063,-0.046 -0.014,-0.077 0.181,-0.004 0.067,0.058 -0.02,0.059 z m 0.112,3.495 -0.008,0.075 -0.144,-0.018 -0.039,-0.034 0.081,-0.261 0.206,-0.12 0.1,-0.024 -0.094,0.124 -0.018,0.139 -0.084,0.119 z m -0.252,0.47 -0.116,0.147 -0.082,-0.229 -0.014,-0.092 0.106,-0.084 0.063,0.001 0.043,0.257 z m -1.115,2.341 -0.14,0.134 -0.1,-0.027 -0.063,-0.046 -0.015,-0.077 0.226,-0.074 0.092,0.026 0,0.064 z",
}
